import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

const Container = styled.div`
`;

const Title = styled.h3`
  margin: 0;
  margin-bottom: 4px;
  padding: 0;
  font-size: 12px !important;
  line-height: 16px !important;
  color: #333333;
  font-weight: bold;
`;

const SelectWrapper = styled.div`
  position: relative;
`;

class Select extends React.Component {

  static propTypes = {
    title: PropTypes.string,
    selectedValue: PropTypes.string,
    options: PropTypes.array,
    isLoading: PropTypes.bool,
    onValueChange: PropTypes.func,
    getValue: PropTypes.func,
    getOptionText: PropTypes.func,
    getOptionHint: PropTypes.func
  }

  renderOptions = () => {
    return this.props.options.map((option) => {
      return (
        { value: this.props.getValue(option), label: this.props.getOptionText(option)}
      );
    });
  }

  render = () => {
    return (
      <Container>
        <Title>{this.props.title}</Title>
        <SelectWrapper>
          <ReactSelect
              isDisabled={this.props.isLoading}
              value={{ value: this.props.selectedValue, label: this.props.getOptionText({key: this.props.selectedValue})}}
              onChange={(e) => {
                this.props.onValueChange(e.value);
              }}
              options={this.renderOptions()}
              isSearchable={false}
              menuPlacement={"bottom"}>
          </ReactSelect>
        </SelectWrapper>
      </Container>
    );
  }

}

class SurveyDropdown extends React.Component {

  static propTypes = {
    question: PropTypes.object,
    surveyAnswers: PropTypes.object,
    getLabel: PropTypes.func,
    onChange: PropTypes.func,
  }

  render = () => {
    let answerValue = null;
    if(this.props.surveyAnswers[this.props.question.key] &&
      this.props.surveyAnswers[this.props.question.key].answer &&
      this.props.surveyAnswers[this.props.question.key].answer.value){
        answerValue = this.props.surveyAnswers[this.props.question.key].answer.value;
    }
    return (
      <Select
        title={''}
        selectedValue={answerValue}
        options={this.props.question.values}
        isLoading={false}
        onValueChange={(e) => {
          const value = e;
          if (value !== answerValue) {
            this.props.onChange(value);
          }
        }}
        getValue={(opt) => opt.key}
        getOptionText={(opt) => this.props.getLabel(opt.key)}
        getOptionHint={(opt) => this.props.getLabel(opt.key)}
      >
      </Select>
    );
  }
}

export default SurveyDropdown;
